import tagsData from "./tags.json";

const { tags: TAG_TABLE } = tagsData;

export const SPECIAL_TAGS = ["Cafe", "Bar"];
const SPECIAL_LOOKUP = new Map(SPECIAL_TAGS.map((t) => [t.toLowerCase(), t]));

/**
 * Alle språk vi lagrer. Språk som finnes i tags.json får gratis oppslag;
 * språk som IKKE finnes der (f.eks. de_DE) går rett til DeepL.
 * Legg til nye språk her – resten følger automatisk.
 */
export const SUPPORTED_LANGS = ["en_US", "nb_NO", "es_ES", "sv_SE", "nl_NL"];

/** Interne språknøkler -> DeepL sine koder. */
const DEEPL_CODE = {
  en_US: "en-US",
  nb_NO: "nb",
  es_ES: "es",
  sv_SE: "sv",
  nl_NL: "nl",
};

export const toDeepL = (langKey) =>
  DEEPL_CODE[langKey] ?? String(langKey).split("_")[0];

export const normalizeLang = (lang) => {
  if (!lang) return null;
  const raw = String(lang).replace("-", "_");
  const lower = raw.split("_")[0].toLowerCase();

  const exact = SUPPORTED_LANGS.find(
    (k) => k.toLowerCase() === raw.toLowerCase(),
  );
  if (exact) return exact;

  return SUPPORTED_LANGS.find((k) => k.split("_")[0] === lower) ?? null;
};

/** true hvis språket har en kolonne i tags.json */
const hasTable = (langKey) => Array.isArray(TAG_TABLE[langKey]);

const indexCache = new Map();
const getIndexMap = (langKey) => {
  if (indexCache.has(langKey)) return indexCache.get(langKey);
  const map = new Map();
  (TAG_TABLE[langKey] ?? []).forEach((tag, i) => {
    const key = tag.toLowerCase();
    if (!map.has(key)) map.set(key, i);
  });
  indexCache.set(langKey, map);
  return map;
};

/** Slår opp én tag lokalt. Returnerer null hvis den ikke finnes i tabellen. */
export const lookupTag = (tag, fromLang, toLang) => {
  if (typeof tag !== "string" || !tag.trim()) return null;
  const trimmed = tag.trim();

  const special = SPECIAL_LOOKUP.get(trimmed.toLowerCase());
  if (special) return special;

  const fromKey = normalizeLang(fromLang);
  const toKey = normalizeLang(toLang);
  if (!fromKey || !toKey) return null;
  if (fromKey === toKey) return trimmed;
  if (!hasTable(fromKey) || !hasTable(toKey)) return null;

  const idx = getIndexMap(fromKey).get(trimmed.toLowerCase());
  if (idx === undefined) return null;

  return TAG_TABLE[toKey][idx] ?? null;
};